import { render, staticRenderFns } from "./livevideo.vue?vue&type=template&id=b081d078&scoped=true&"
import script from "./livevideo.vue?vue&type=script&lang=js&"
export * from "./livevideo.vue?vue&type=script&lang=js&"
import style0 from "./livevideo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./livevideo.vue?vue&type=style&index=1&id=b081d078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b081d078",
  null
  
)

export default component.exports